import { useEffect, useRef } from 'react';

export function useAkamaiResubmission<T extends HTMLFormElement>() {
  const formRef = useRef<T>(null);

  useEffect(() => {
    const handleAkamaiChallengeEvent = () => {
      if (formRef.current) {
        formRef.current?.requestSubmit();
      }
    };

    document.addEventListener('akamai-challenge-noreload', handleAkamaiChallengeEvent);

    return () => {
      document.removeEventListener('akamai-challenge-noreload', handleAkamaiChallengeEvent);
    };
  }, []);

  return formRef;
}
